export const QUERY_TIME_CONFIG = {
  /** 5 minutes - shorter time for polling queries */
  POLLING_GC_TIME: 1000 * 60 * 5,
  /** 30 minutes */
  DEFAULT_GC_TIME: 1000 * 60 * 30,

  DEFAULT_STALE_TIME: 5_000, // 5 seconds - assume nothing will have changed in that time

  /** 20 minutes - org and system reference data that only an admin can change */
  REFERENCE_DATA_STALE_TIME: 1000 * 60 * 20,
} as const

/**
 * Get appropriate gcTime based on whether the query is polling
 * @param refetchInterval - The refetch interval (number or boolean)
 * @returns gcTime value for the query
 */
export const getPollingGCTime = (refetchInterval?: number | boolean): number | undefined => {
  return refetchInterval ? QUERY_TIME_CONFIG.POLLING_GC_TIME : undefined
}
